import React, { useEffect } from "react";
import {
  CCMetalPowderAutomizationData,
  CCMetalVolumePartReductionData,
  CCMetalCo2ePowderScenarioMData,
  CCMetalPowderAutomizationState,
  CCMetalGreenEnergyMixData,
  CCMetalInertGasReductionSMData,
  CCMetalCo2TotalTodaySMData,
  CCMetalCo2TotalTomorrowSMData,
  CCMetalVolumePartReductionState,
  CCMetalModeOfTransportNode1,
  CCMetalModeOfTransportNode2,
  CCMetalModeOfTranspotation1,
  CCMetalModeOfTranspotation2,
  CCMetalGreenEnergyMixDataInput,
  CCMetalTotalTraspotation,
} from "atoms/CCCarbonMetal/CCMetalScenario";
import { Spinner } from "react-bootstrap";
import { useRecoilState } from "recoil";
import SelectDropdown from "app/components/SelectDropdown";
import { PercentageData, YesNoData, LogisticsData } from "utils/selectDropdowns";
import { useRoundOffValue } from "app/components/hooks/useRoundOffValue";
import TooltipTrippy from "app/components/ProductionScenario/TooltipTrippy";

const { getComputedValue } = useRoundOffValue();

const MaterialTableValuesNew = ({ socket, fieldObj, isBold = false }) => {
  const [, setPowderAutomization] = useRecoilState(CCMetalPowderAutomizationData);
  const [volumePartReduction, setVolumePartReduction] = useRecoilState(
    CCMetalVolumePartReductionData
  );
  const [co2ePowder, setCo2EPowder] = useRecoilState(
    CCMetalCo2ePowderScenarioMData
  );
  const [greenEnergyMix, setGreenEnergyMix] = useRecoilState(
    CCMetalGreenEnergyMixData
  );
  const [inertGasReduction, setInertGasReduction] = useRecoilState(
    CCMetalInertGasReductionSMData
  );

  const [, setCo2TotalToday] = useRecoilState(CCMetalCo2TotalTodaySMData);
  const [, setCo2TotalTomorrow] = useRecoilState(CCMetalCo2TotalTomorrowSMData);
  const [powderAtomizationState, setPowderAutomizationState] = useRecoilState(
    CCMetalPowderAutomizationState
  );

  const [modeOfTransportnode1, setmodeOfTransportnode1] = useRecoilState(
    CCMetalModeOfTransportNode1
  );
  const [modeOfTransportnode2, setmodeOfTransportnode2] = useRecoilState(
    CCMetalModeOfTransportNode2
  );

  const [modeOfTranspotation1, setModeOfTranspotation1] = useRecoilState(
    CCMetalModeOfTranspotation1
  );
  const [modeOfTranspotation2, setModeOfTranspotation2] = useRecoilState(
    CCMetalModeOfTranspotation2
  );

  const [totalTranpotation, setTotalTraspotation] = useRecoilState(
    CCMetalTotalTraspotation
  );

  const co2EmissionPowder = fieldObj?.co2EmissionPowder;
  const CCMetalCo2ePerPartPMData = fieldObj?.CCMetalCo2ePerPartPMData;
  const co2eEmissionFactor = fieldObj?.co2eEmissionFactor;
  const materialTransportaion = +fieldObj?.materialTransportaion;
  const systemTransportation = +fieldObj?.systemTransportation;
  const cefnone = fieldObj?.cefnone;
  const cefnTwo = fieldObj?.cefnTwo;
  const co2EmissionBuildProcess = fieldObj?.co2EmissionBuildProcess;
  const [volumerPartReductionState, setVolumePartReductionState] =
    useRecoilState(CCMetalVolumePartReductionState);
  const co2EmissionGas = fieldObj?.co2EmissionGas;
  const [greenEnergymixState, setGreenEnergyMixState] = useRecoilState(
    CCMetalGreenEnergyMixDataInput
  );

  useEffect(() => {
    setPowderAutomizationState(fieldObj?.powderAtomizationInput);
    setVolumePartReductionState(fieldObj?.volumerPartReductionStateInput);
    setGreenEnergyMixState(fieldObj?.greenEnergymixStateInput);
    setModeOfTranspotation1(fieldObj?.modeOfTranspotation1Input);
    setModeOfTranspotation2(fieldObj?.modeOfTranspotation2Input);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldObj]);

  useEffect(() => {
    if (modeOfTranspotation1 && modeOfTranspotation2) {
      socket.emit("carbon-calculator", {
        key: "MSA-MCT",
        input: {
          node1_mode: modeOfTranspotation1,
          node2_mode: modeOfTranspotation2,
          material_transportation: parseInt(materialTransportaion),
          system_transportation: parseInt(systemTransportation),
          carbon_emission_factor_node_1: +cefnone,
          carbon_emission_factor_node_2: +cefnTwo,
          utilization: +fieldObj?.costData?.utilization?.value,
          build_time: +fieldObj?.costData?.build_time?.value,
          setup_time: +fieldObj?.costData?.setup_time?.value,
          unpacking_time_per_job: +fieldObj?.costData?.unpacking_time_per_job?.value,
        },
      });

      socket.on("MSA-MCT", function (data) {
        let value_node_1_today = data?.data?.transport_node_1_today.toFixed(3);
        let value_node_1_tomorrow =
          data?.data?.transport_node_1_tomorrow.toFixed(3);
        let value_node_2_today = data?.data?.transport_node_2_today.toFixed(3);
        let value_node_2_tomorrow =
          data?.data?.transport_node_2_tomorrow.toFixed(3);

        const transportNode1Today =
          value_node_1_today.slice(-1) === "0"
            ? data?.data?.transport_node_1_today.toFixed(5)
            : value_node_1_today;
        const transportNode1Tomorrow =
          value_node_1_tomorrow.slice(-1) === "0"
            ? data?.data?.transport_node_1_tomorrow.toFixed(5)
            : value_node_1_tomorrow;
        const transportNode2Today =
          value_node_2_today.slice(-1) === "0"
            ? data?.data?.transport_node_2_today.toFixed(5)
            : value_node_2_today;
        const transportNode2Tomorrow =
          value_node_2_tomorrow.slice(-1) === "0"
            ? data?.data?.transport_node_2_tomorrow.toFixed(5)
            : value_node_2_tomorrow;

        setmodeOfTransportnode1({
          today: transportNode1Today,
          tomorrow: transportNode1Tomorrow,
        });
        setmodeOfTransportnode2({
          today: transportNode2Today,
          tomorrow: transportNode2Tomorrow,
        });
        setTotalTraspotation({
          today:
            transportNode1Today.length > 5 || transportNode2Today.length > 5
              ? data?.data?.transport_today.toFixed(5)
              : getComputedValue(data?.data?.transport_today),
          tomorrow:
            transportNode1Tomorrow.length > 5 ||
            transportNode2Tomorrow.length > 5
              ? data?.data?.transport_tomorrow.toFixed(5)
              : getComputedValue(data?.data?.transport_tomorrow),
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modeOfTranspotation1, modeOfTranspotation2]);

  useEffect(() => {
    if (
      powderAtomizationState &&
      volumerPartReductionState &&
      CCMetalCo2ePerPartPMData
    ) {
      socket.emit("carbon-calculator", {
        key: "MSA-MCP",
        input: {
          atomizedType: powderAtomizationState,
          co2_emission_powder: co2EmissionPowder,
          reduction_in_volume: volumerPartReductionState,
          powder_energy_per_part: CCMetalCo2ePerPartPMData,
          co2_emission_factor: co2eEmissionFactor,
          no_of_parts: parseInt(fieldObj?.costData?.no_of_parts?.value),
          part_volume: parseInt(fieldObj?.costData?.part_volume?.value),
          part_support_volume: parseInt(
            fieldObj?.costData?.part_support_volume?.value
          ),
          material_id: parseInt(fieldObj?.costData?.material_id?.value),
        },
      });

      socket.on("MSA-MCP", function (data) {
        const valuepatod = getComputedValue(
          data?.data?.powder_atomization_today
        );
        const valuepatom = getComputedValue(
          data?.data?.powder_atomization_tomorrow
        );
        const valuecptod = getComputedValue(data?.data?.co2e_powder_today);
        const valuecptom = getComputedValue(data?.data?.co2e_powder_tomorrow);
        const valuevptod = getComputedValue(
          data?.data?.volume_of_the_part_reduction_today
        );
        const valuevptom = getComputedValue(
          data?.data?.volume_of_the_part_reduction_tomorrow
        );
        setPowderAutomization({ today: valuepatod, tomorrow: valuepatom });
        setCo2EPowder({ today: valuecptod, tomorrow: valuecptom });
        setVolumePartReduction({ today: valuevptod, tomorrow: valuevptom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [powderAtomizationState, volumerPartReductionState, CCMetalCo2ePerPartPMData]);

  useEffect(() => {
    if (greenEnergymixState) {
      socket.emit("carbon-calculator", {
        key: "MSA-MCE",
        input: {
          isGreenEnergyMix: greenEnergymixState,
          co2_emission_build_process: co2EmissionBuildProcess,
        },
      });

      socket.on("MSA-MCE", function (data) {
        const valuepatod = getComputedValue(data.data.green_energy_mix_today);
        const valuepatom = getComputedValue(
          data.data.green_energy_mix_tomorrow
        );
        setGreenEnergyMix({ today: valuepatod, tomorrow: valuepatom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [greenEnergymixState]);

  useEffect(() => {
    if (co2EmissionGas) {
      socket.emit("carbon-calculator", {
        key: "MSA-MCG",
        input: { co2_emission_gas: co2EmissionGas },
      });

      socket.on("MSA-MCG", function (data) {
        const valuepatod = getComputedValue(
          data.data.inert_gas_reduction_today
        );
        const valuepatom = getComputedValue(
          data.data.inert_gas_reduction_tomorrow
        );
        setInertGasReduction({ today: valuepatod, tomorrow: valuepatom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      co2ePowder !== undefined &&
      inertGasReduction !== undefined &&
      totalTranpotation !== undefined
    ) {
      const value =
        parseFloat(co2ePowder.today) +
        parseFloat(inertGasReduction.today) +
        parseFloat(totalTranpotation?.today);
      const value1 = getComputedValue(value);
      setCo2TotalToday(value1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [co2ePowder, inertGasReduction, volumePartReduction, totalTranpotation]);

  useEffect(() => {
    if (
      co2ePowder !== undefined &&
      inertGasReduction !== undefined &&
      totalTranpotation !== undefined
    ) {
      const value =
        parseFloat(co2ePowder.tomorrow) +
        parseFloat(inertGasReduction.tomorrow) +
        parseFloat(totalTranpotation?.tomorrow);
      const value1 = getComputedValue(value);
      setCo2TotalTomorrow(value1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [co2ePowder, inertGasReduction, volumePartReduction, totalTranpotation]);

  return (
    <div className="d-flex flex-column gap-16">
      {/* CO2e Powder */}
      <div className="d-flex flex-column scenario_container">
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Powder</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">Future Scenario</div>
        </div>
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            How much volume reduction in % is possible with redesign?
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setVolumePartReductionState}
              getState={volumerPartReductionState}
              Dataset={PercentageData}
              styleclass=" dropdown-input_select select_wrapper_text"
              optionAvailable={false}
            />
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {volumePartReduction ? volumePartReduction.today : "_ _ _ _"}
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {volumePartReduction?.tomorrow !== undefined ? (
              volumePartReduction?.tomorrow
            ) : (
              <Spinner animation="border" size="sm" />
            )}
          </div>
        </div>
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Powder (kg)
          </span>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>&nbsp;</div>
          <div className="  scenario_cell ">
            {co2ePowder ? co2ePowder.today : "_ _ _ _"}
          </div>
          <div className="  scenario_cell">
            {co2ePowder?.tomorrow !== undefined ? (
              co2ePowder?.tomorrow
            ) : (
              <Spinner animation="border" size="sm" />
            )}
          </div>
        </div>
      </div>

      {/* CO2e Energy */}
      <div className="d-flex flex-column scenario_container">
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Energy</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">Future Scenario</div>
        </div>
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            Is there a possibility to switch to a green energy mix?
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setGreenEnergyMixState}
              getState={greenEnergymixState}
              Dataset={YesNoData}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {greenEnergyMix ? greenEnergyMix.today : "_ _ _ _ "}
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {greenEnergyMix?.tomorrow !== undefined ? (
              greenEnergyMix?.tomorrow
            ) : (
              <Spinner animation="border" size="sm" />
            )}
          </div>
        </div>
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">Inert Gas Reduction</span>
          <div className=" scenario_cell select_wrapper">&nbsp;</div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {inertGasReduction ? inertGasReduction.today : "_ _ _ _"}
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {inertGasReduction?.tomorrow !== undefined ? (
              inertGasReduction?.tomorrow
            ) : (
              <Spinner animation="border" size="sm" />
            )}
          </div>
        </div>
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Energy (kg)
          </span>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>&nbsp;</div>
          <div className="  scenario_cell ">
            {/* energy total for CCMetal is combined in transportation calc; display not present in original */}
            {greenEnergyMix && inertGasReduction
              ? getComputedValue(
                  parseFloat(inertGasReduction.today) +
                    parseFloat(greenEnergyMix.today)
                )
              : "_ _ _ _"}
          </div>
          <div className="  scenario_cell">
            {greenEnergyMix && inertGasReduction && inertGasReduction?.tomorrow !== undefined
              ? getComputedValue(
                  parseFloat(inertGasReduction.tomorrow) +
                    parseFloat(greenEnergyMix.tomorrow)
                )
              : <Spinner animation="border" size="sm" />}
          </div>
        </div>
      </div>

      {/* CO2e Logistics */}
      <div className="d-flex flex-column scenario_container">
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Logistics</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">Future Scenario</div>
        </div>
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">Change the mode of logistics (node 1)</span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setModeOfTranspotation1}
              getState={modeOfTranspotation1}
              Dataset={LogisticsData}
              styleclass=" dropdown-input_select select_wrapper_text"
            />
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {modeOfTransportnode1 !== undefined
              ? modeOfTransportnode1.today
              : "_ _ _ _"}
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {modeOfTransportnode1 !== undefined
              ? modeOfTransportnode1.tomorrow
              : "_ _ _ _"}
          </div>
        </div>
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">Change the mode of logistics (node 2)</span>
          <div className=" scenario_cell  select_wrapper">
            <SelectDropdown
              setState={setModeOfTranspotation2}
              getState={modeOfTranspotation2}
              Dataset={LogisticsData}
              styleclass=" dropdown-input_select select_wrapper_text"
            />
          </div>
        <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {modeOfTransportnode2 !== undefined
              ? modeOfTransportnode2.today
              : "_ _ _ _"}
          </div>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>
            {modeOfTransportnode2 !== undefined
              ? modeOfTransportnode2.tomorrow
              : "_ _ _ _"}
          </div>
        </div>
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Logistics (kg)
          </span>
          <div className={" font-14   scenario_cell " + (!isBold ? "font-semi-bold" : "")}>&nbsp;</div>
          <div className="  scenario_cell ">
            {totalTranpotation ? totalTranpotation?.today : "_ _ _ _"}
          </div>
          <div className="  scenario_cell">
            {totalTranpotation ? (
              totalTranpotation?.tomorrow
            ) : (
              <Spinner animation="border" size="sm" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialTableValuesNew;


